var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proflistcard[data-v-25cb2c20]{min-height:275px;padding:10px;display:-ms-grid;display:grid;-ms-grid-columns:1fr;grid-template-columns:1fr;-ms-grid-rows:159px 1fr 34px;grid-template-rows:159px 1fr 34px;row-gap:13px;text-decoration:none;background-color:#fff;transition:box-shadow .2s ease-in;box-shadow:3px 3px 3px rgba(0,0,0,.1);position:relative}.proflistcard[data-v-25cb2c20]:hover{box-shadow:3px 3px 3px rgba(0,0,0,.2)}.proflistcard__main[data-v-25cb2c20]{position:relative}.proflistcard__main[data-v-25cb2c20]:after{content:\"\";height:5px;width:100%;position:absolute;bottom:0;left:0;background:url(" + escape(require("./assets/snake.png")) + ") 50% 0 no-repeat}.proflistcard__btn[data-v-25cb2c20]{justify-self:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25cb2c20","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/professions/card/ProfessionListCard.vue
// module id = 1610273e3115bff31a2f
// module chunks = 0